unable to read source [project]/packages/analitica/src/lib/analitica.ts